import { Box } from '@mui/material';
import { DataGridPro, DataGridProProps, GridColDef } from '@mui/x-data-grid-pro';
import React from 'react';

import { RouterLink } from 'app/components/router-link';
import { Category } from 'app/model/cris/category';
import { DataGridFormatters } from 'app/utils/data-grid-formatters';

interface CategoryListGridProps extends Omit<DataGridProProps<Category>, 'columns'> {
    rows: Category[];
}

export const CategoryListGrid: React.FunctionComponent<CategoryListGridProps> = (props) => (
    <Box sx={{ width: '100%', display: 'grid', height: '100%' }}>
        <DataGridPro {...props} columns={columns} />
    </Box>
);

const columns: Array<GridColDef<Category>> = [
    {
        field: 'id',
        headerName: 'ID',
        width: 150,
    },
    {
        field: 'category',
        headerName: 'Category',
        width: 250,
        renderCell: (data) => <RouterLink to={`/cris/categories/${data.row.id}`}>{data.value}</RouterLink>,
    },
    {
        field: 'dateCreated',
        headerName: 'Date Created',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
    {
        field: 'dateEdited',
        headerName: 'Date Edited',
        width: 200,
        valueFormatter: DataGridFormatters.dateTimeFormatter,
    },
];
